<template>
    <v-dialog v-if="dialog" v-model="dialog" :width="width" @keydown.esc="cancel(true)" @click:outside="cancel(true)" :attach="attach" :persistent="persistent">
        <v-card>
            <v-toolbar dark dense flat :color="color">
                <v-toolbar-title class="text-body-1 font-weight-bold white--text" v-html="title" />
            </v-toolbar>
            <PerfectScrollbar v-if="debugItems.length > 0" class="px-4" style="width: 100%; max-height: 60vh">
                <!-- <div v-if="debugItems.length > 0" class="scrollbox2 pa-4" style="width: 100%; max-height: 60vh"> -->
                <table class="styled-table" width="100%">
                    <thead style="position: sticky; top: 0">
                        <tr>
                            <th>Clave</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in debugItems" :key="i">
                            <td>{{ item.key }}</td>
                            <td style="white-space: pre-wrap; overflow-x: scroll; font-family: courier">{{ item.value }}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- </div> -->
            </PerfectScrollbar>
            <div v-else class="d-flex align-center pt-4">
                <v-icon v-if="icon" :color="iconColor" size="64" class="px-4">{{ icon }}</v-icon>
                <div class="d-flex flex-column flex-grow-1">
                    <v-card-text v-show="!!message" class="pa-4 black--text text-body-1" v-html="message" />
                    <template v-for="(message, i) in messages">
                        <v-divider v-if="message === '-'" :key="i" class="my-4" />
                        <div v-else-if="isPreArea(message)" :key="i" class="scrollbox2" style="width: 99%; max-width: 99%; max-height: 40vh">
                            <div style="white-space: pre-wrap" v-html="getPreArea(message)" />
                        </div>
                        <v-card-text v-else-if="isIndentedSmallText(message)" :key="i" class="pl-8 my-0 py-0 text-caption">{{ getIndentedSmallText(message) }}</v-card-text>
                        <v-card-text v-else-if="isSmallText(message)" :key="i" class="pl-4 my-0 py-0 text-caption">{{ getSmallText(message) }}</v-card-text>
                        <v-card-text v-else-if="containsLink(message)" :key="i" class="pl-4 pt-1 black--text text-body-1 d-flex align-center">
                            <span v-html="message" />
                            <v-btn small icon @click="copyLinkFromMessageIntoClipboard(message)">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                            <v-btn small icon @click="openLinkFromMessageInNewTab(message)">
                                <v-icon>mdi-open-in-new</v-icon>
                            </v-btn>
                        </v-card-text>
                        <v-card-text v-else :key="i" class="pl-4 pt-1 black--text text-body-1" v-html="message" />
                    </template>
                    <!-- <v-card-text v-for="(message, i) in messages" :key="i" class="pl-4 pt-1 black--text text-body-1" v-html="message" /> -->

                    <v-card-text v-for="(question, i) in questions" :key="`q-${i}`" class="pl-4 pt-1 black--text text-body-1">
                        <v-checkbox hide-details v-model="question.checked" :label="question.text" />
                    </v-card-text>

                    <v-card-text v-for="(input, i) in inputs" :key="`i-${i}`" class="pl-4 pt-1 black--text text-body-1">
                        <v-switch v-if="input.type === 'switch'" :ref="`input-${i}`" v-model="input.value" :label="input.label" />
                        <v-select
                            v-else-if="input.type === 'select'"
                            :ref="`input-${i}`"
                            dense
                            outlined
                            hide-details
                            v-model="input.value"
                            :label="input.label"
                            autocomplete="new"
                            :items="input.items"
                            item-value="id"
                            item-text="name"
                        />
                        <v-text-field
                            v-else-if="input.type === 'number'"
                            :ref="`input-${i}`"
                            dense
                            outlined
                            hide-details
                            v-model.number="input.value"
                            :label="input.label"
                            autocomplete="new"
                            @keypress="isNumber($event)"
                        />
                        <v-text-field
                            v-else-if="input.type === 'text'"
                            :ref="`input-${i}`"
                            dense
                            outlined
                            hide-details
                            v-model="input.value"
                            :label="input.label"
                            :disabled="input.disabled"
                            autocomplete="new"
                        />
                        <v-text-field
                            v-else-if="input.type === 'date'"
                            :ref="`input-${i}`"
                            dense
                            outlined
                            hide-details
                            av-model="input.value"
                            :value="input.value"
                            @input="setInputDate(input, $event)"
                            @achange="setInputDate(input, $event)"
                            :label="input.label"
                            v-mask="`##/##/####`"
                            placeholder="DD/MM/YYYY"
                            autocomplete="new"
                            style="width: 164px"
                            :disabled="input.disabled"
                        >
                            <template #append>
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn small elevation="0" class="px-1" v-on="on" v-bind="attrs" style="margin-top: -2px; min-width: 16px" :disabled="input.disabled">
                                            <v-icon class="mr">mdi-calendar</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-date-picker
                                        no-title
                                        locale="es-es"
                                        :first-day-of-week="1"
                                        :value="getInputDate(input)"
                                        @change="setInputDate(input, $event)"
                                        scrollable
                                        class="booking-calendar"
                                        :min="input.minimumValue ? input.minimumValue : undefined"
                                        :max="input.maximumValue ? input.maximumValue : undefined"
                                    ></v-date-picker>
                                </v-menu>
                            </template>
                        </v-text-field>

                        <v-textarea
                            v-else-if="input.type === 'text-area'"
                            :ref="`input-${i}`"
                            dense
                            outlined
                            hide-details
                            v-model="input.value"
                            :label="input.label"
                            :rows="input.rows ? input.rows : 5"
                            autocomplete="new"
                        />

                        <div v-else-if="input.type === 'time-range'" class="d-flex align-center">
                            <span class="font-weight-bold text-body-1">{{ input.label }} :</span>
                            <v-text-field
                                dense
                                outlined
                                hide-details
                                :value="getTimeFromRange(input, 0)"
                                @input="setTimeInRange(input, 0, $event)"
                                append-icon="mdi-clock-time-four-outline"
                                label="Inicio"
                                v-mask="`##:##`"
                                placeholder="HH:MM"
                                autocomplete="new"
                                style="width: 164px"
                                class="ml-2"
                            ></v-text-field>

                            <v-text-field
                                dense
                                outlined
                                hide-details
                                :value="getTimeFromRange(input, 1)"
                                @input="setTimeInRange(input, 1, $event)"
                                append-icon="mdi-clock-time-four-outline"
                                label="Inicio"
                                v-mask="`##:##`"
                                placeholder="HH:MM"
                                autocomplete="new"
                                style="width: 164px"
                                class="ml-2"
                            ></v-text-field>
                        </div>

                        <div v-if="input.comment" class="pt-1 text-caption grey--text text-lighten-4" v-html="input.comment" />

                        <div v-if="input.type === 'date' && input.minimumValue && input.maximumValue" class="pt-1 text-caption grey--text text-lighten-4">
                            Rango permitido: desde
                            <strong>{{ formatDate(input.minimumValue) }}</strong>
                            hasta
                            <strong>{{ formatDate(input.maximumValue) }}</strong>
                        </div>
                    </v-card-text>

                    <v-card-text v-if="warningMessage" class="pl-4 pt-1 text-body-1">
                        <v-checkbox v-model="warningMessageChecked">
                            <template v-slot:label>
                                <span class="red--text text--lighten-2" v-html="warningMessage"></span>
                            </template>
                        </v-checkbox>
                    </v-card-text>
                </div>
            </div>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn v-if="!nocancel" :color="cancelButtonColor" text class="body-2 font-weight-bold" @click.native="cancel(false)">{{ cancelButtonText }}</v-btn>
                <v-btn :color="buttonColor" class="body-2 font-weight-bold" @click.native="accept" :disabled="disableAccept">{{ acceptButtonText }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">
.styled-table {
    border-collapse: collapse;
    font-size: 0.9em;
    font-family: sans-serif;
    min-width: 400px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.styled-table thead tr {
    background-color: #009879;
    color: #ffffff;
    text-align: left;
}

.styled-table th,
.styled-table td {
    padding: 12px 15px;
}

.styled-table tbody tr {
    border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #009879;
}

.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #009879;
}
</style>

<script lang="ts">
import { EventBus } from "@/components/EventBus";
import { ConfirmationDialogRequest, DataClient } from "@/services/DataClient";
import { Utilities } from "@/services/Utilities";
import { Component, Vue } from "vue-property-decorator";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { VBtn, VCard, VDialog } from "vuetify/lib";
import { BaseView } from "../BaseView";

interface Question {
    text: string;
    checked: boolean;
}

interface Input {
    type?: "text" | "date" | "text-area" | "select" | "number" | "switch" | "time-range";
    label: string;
    value: string | boolean;
    items?: Array<{ id: string; name: string }>;
    required?: boolean;
    rows?: number;
    disabled?: boolean;
    comment?: string;
    minimumValue?: string;
    maximumValue?: string;
}

interface DebugItem {
    key: string;
    value: string;
}

@Component
export default class extends BaseView {
    dialog = false;

    title = "";
    message = "";
    messages: string[] = [];
    warningMessage = "";
    questions: Question[] = [];
    inputs: Input[] = [];
    nocancel = false;
    width = "";
    color = "";
    icon = "";
    iconColor = "";
    buttonColor = "";
    cancelButtonColor = "";
    warningMessageChecked = false;
    debugItems: DebugItem[] = [];
    acceptButtonText = "Aceptar";
    cancelButtonText = "Cancelar";
    attach: any = null;
    persistent = false;

    mounted() {
        EventBus.$on(DataClient.Dialogs.OpenConfirmationDialogEvent, this.handleOpenEvent);
    }

    beforeDestroy() {
        EventBus.$off(DataClient.Dialogs.OpenConfirmationDialogEvent, this.handleOpenEvent);
    }

    reset() {
        this.dialog = false;
    }

    get disableAccept() {
        if (this.warningMessage && !this.warningMessageChecked) {
            return true;
        }

        for (const input of this.inputs) {
            if (!input.required) {
                continue;
            }

            if (input.type === "date") {
                if (!Utilities.isValidDateDDMMYYYY(input.value as string)) {
                    return true;
                }

                if (input.minimumValue || input.maximumValue) {
                    const inputDate = Utilities.formatDateToYYYYMMDD(input.value as string);
                    if (input.minimumValue) {
                        if (inputDate < input.minimumValue) {
                            return true;
                        }
                    }

                    if (input.maximumValue) {
                        if (inputDate > input.maximumValue) {
                            return true;
                        }
                    }
                }
            }

            if (input.type === "number" && (input.value === undefined || input.value === null || input.value === "")) {
                return true;
            } else if (input.type !== "number" && !input.value) {
                return true;
            }
        }

        // if (this.inputs.some((i) => i.required && !i.value)) {
        //     return true;
        // }

        return false;
    }

    async handleOpenEvent(event: ConfirmationDialogRequest) {
        this.title = event.title;
        this.message = this.buildHtmlFromRawMessage(event.message || "");
        this.messages = (event.messages || []).map((m) => this.buildHtmlFromRawMessage(m));
        this.warningMessage = event.warningMessage || "";
        this.questions = (event.questions || []).map((q) => ({ text: q.startsWith("*") ? q.substring(1) : q, checked: q.startsWith("*") }));
        this.inputs = (event.inputs || [])
            .filter((i) => i !== undefined)
            .map((i: any) => ({
                type: i.type || "text",
                label: i.label || "",
                value: i.value || "",
                items: i.items || [],
                required: i.required || false,
                rows: i.rows || 5,
                disabled: i.disabled || false,
                comment: i.comment || "",
                minimumValue: i.minimumValue || "",
                maximumValue: i.maximumValue || "",
            }));
        this.nocancel = event.nocancel || false;
        this.color = event.color || "#2B3848";
        this.width = event.width || "600";
        this.icon = event.icon || "";
        this.iconColor = event.iconColor || "orange darken-2";
        this.buttonColor = event.buttonColor || "primary";
        this.cancelButtonColor = event.cancelButtonColor || "gray";
        this.warningMessageChecked = false;

        if (event.debug) {
            this.debugItems = Object.keys(event.debug).map((k) => ({ key: k, value: event.debug[k] }));
        } else {
            this.debugItems = [];
        }

        this.acceptButtonText = event.acceptButtonText || "Aceptar";
        this.cancelButtonText = event.cancelButtonText || "Cancelar";
        this.attach = event.attach || undefined;
        this.persistent = event.persistent || false;

        this.dialog = true;

        if (this.inputs.length > 0) {
            Utilities.focus(this, "input-0");
        }
    }

    accept() {
        const inputs: string[] = [];
        for (const input of this.inputs) {
            if (input.type === "date") {
                inputs.push(input.value ? Utilities.formatDateToYYYYMMDD(input.value as string) : "");
            } else if (input.type === "switch") {
                inputs.push(input.value ? "true" : "false");
            } else {
                inputs.push((input.value as string) || "");
            }
        }

        const questions = this.questions.map((q) => q.checked);

        if (this.inputs.length > 0 && this.questions.length > 0) {
            DataClient.Dialogs.confirmationWithQuestionsAndInputs([true, questions, inputs], true);
        } else if (this.inputs.length > 0) {
            DataClient.Dialogs.confirmationWithInputs([true, ...inputs], true);
        } else if (this.questions.length > 0) {
            DataClient.Dialogs.confirmationWithQuestions([true, ...questions], true);
        } else {
            DataClient.Dialogs.confirmation(true, true);
        }

        this.reset();
    }

    cancel(fromEsc: boolean) {
        if (fromEsc && this.persistent) {
            return;
        }

        if (this.inputs.length > 0 && this.questions.length > 0) {
            DataClient.Dialogs.confirmationWithQuestionsAndInputs([false, [], []], true);
        } else if (this.inputs.length > 0) {
            DataClient.Dialogs.confirmationWithInputs([false, ...this.inputs.map((i) => "")], true);
        } else if (this.questions.length > 0) {
            DataClient.Dialogs.confirmationWithQuestions([false, ...this.questions.map((q) => false)], true);
        } else {
            DataClient.Dialogs.confirmation(false, true);
        }

        this.reset();
    }

    buildHtmlFromRawMessage(message: string): string {
        return message.replace(/\n/g, "<br/>");
    }

    isNumber(evt: KeyboardEvent): void {
        const keysAllowed: string[] = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."];
        const keyPressed: string = evt.key;

        if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault();
        }
    }

    getInputDate(input: Input): string {
        if (!input.value || !Utilities.isValidDateDDMMYYYY(input.value as string)) {
            return "";
        }

        return Utilities.formatDateToYYYYMMDD(input.value as string);
    }

    getTimeFromRange(input: Input, slot: number): string {
        if (!input.value) {
            return "";
        }

        const slots = (input.value as string).split("-");
        return slots[slot] || "";
    }

    setTimeInRange(input: Input, slot: number, time: string): void {
        const slot1 = slot === 0 ? time : this.getTimeFromRange(input, 0);
        const slot2 = slot === 1 ? time : this.getTimeFromRange(input, 1);

        input.value = `${slot1}-${slot2}`;
    }

    setInputDate(input: Input, date: string) {
        if (Utilities.isValidDateYYYYMMDD(date)) {
            // when setting the date from the date picker, it sometimes doesn't update the input field correctly
            // so we set it twice, once immediately and once after a short delay, after the input field has had time to update
            const formattedDate = Utilities.formatDateToDDMMYYYY(date);
            input.value = formattedDate;

            setTimeout(() => {
                input.value = formattedDate;
            }, 100);
        } else {
            input.value = date;
        }
    }

    containsLink(value: string): boolean {
        return !value.includes("src=") && value.includes("https://");
    }

    isPreArea(value: string): boolean {
        return value.startsWith("***");
    }

    isSmallText(value: string): boolean {
        return value.startsWith("*");
    }

    isIndentedSmallText(value: string): boolean {
        return value.startsWith("**");
    }

    getPreArea(value: string): string {
        return value.substring(3);
    }

    getSmallText(value: string): string {
        return value.substring(1);
    }

    getIndentedSmallText(value: string): string {
        return value.substring(2);
    }

    extractLinkFromString(value: string): string {
        // remove <center> & </center> tags
        const sanitized = value.replace(/<center>/g, "").replace(/<\/center>/g, "");
        const matches = sanitized.match(/(https?:\/\/[^\s]+)/g);
        return matches ? matches[0] : "";
    }

    copyLinkFromMessageIntoClipboard(value: string): void {
        const link = Utilities.extractLinkFromHTML(value) || this.extractLinkFromString(value);
        Utilities.copyToClipboardWithFeedback(link, "El enlace ha sido copiado al portapapeles.");
    }

    openLinkFromMessageInNewTab(value: string): void {
        const link = Utilities.extractLinkFromHTML(value) || this.extractLinkFromString(value);
        window.open(link, "_blank");
    }
}
</script>
